/*
 * @Author: Teemo Ding
 * @Date: 2022-02-17 15:44:24
 * @LastEditTime: 2022-06-06 10:36:31
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Communication/Detail/CommunicationGateway/Components/Cloopen.tsx
 */
import { Input, Label, Select } from '@/src/components/Antd';
import Row from '@/src/components/Layouts/Row/Row';
import PasswordInput from '@/src/components/Password';
import { NEW } from '@/src/tools/constant';
import { Form } from 'antd';
import React, { Fragment } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { DestinationType } from 'src/types/common/communication';
import {
  AccountSIDAndAuthToken,
  InputWithValue,
  RadioWithValue,
} from '../../../Components/FormComponents';
import css from '../../css.module.less';
import { OriSelect } from 'src/components/Antd';
const Option = OriSelect.Option;

const Cloopen = ({
  editable,
  communicationUuid,
  handleResetInput,
  unlockEditable,
  disabled,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const destinationOptions = [
    {
      label: getI18n('storeCommunicationSetting.tool.mainlandChina'),
      value: DestinationType.Mainland,
    },
    {
      label: getI18n('storeCommunicationSetting.detail.other'),
      value: DestinationType.NonMainland,
    },
  ];
  return (
    <Fragment>
      <AccountSIDAndAuthToken
        editable={editable}
        communicationUuid={communicationUuid}
        handleResetInput={handleResetInput}
        unlockEditable={unlockEditable}
        disabled={disabled}
      />

      <Row
        elements={[
          {
            child: (
              <Form.Item
                name='appId'
                labelCol={{ span: 24 }}
                label={
                  <Label
                    title={`${getI18n(
                      'storeCommunicationSetting.detail.appID',
                    )}*`}
                  />
                }>
                <InputWithValue edit={editable}>
                  <PasswordInput
                    editable={
                      communicationUuid === NEW ||
                      unlockEditable.includes('appId')
                    }
                    onEdit={() => handleResetInput('appId')}
                    passwordProps={{ maxLength: 100 }}
                    disabled={disabled}
                  />
                </InputWithValue>
              </Form.Item>
            ),
          },
          {
            child: (
              <Form.Item
                labelCol={{ span: 24 }}
                label={
                  <Label
                    title={`${getI18n(
                      'storeCommunicationSetting.detail.portHost',
                    )}*`}
                  />
                }
                style={{ marginBottom: 0 }}>
                <Form.Item
                  initialValue={'app.cloopen.com'}
                  name='host'
                  rules={[{ required: true }]}
                  className={css.host}
                  style={{
                    display: 'inline-block',
                    width: 'calc(50% - 8px)',
                  }}>
                  <InputWithValue edit={editable}>
                    <Select size='large'>
                      <Option value='app.cloopen.com'>app.cloopen.com</Option>
                      <Option value='hksms.cloopen.com'>
                        hksms.cloopen.com
                      </Option>
                    </Select>
                  </InputWithValue>
                  {/* <InputWithValue edit={editable}>
                    <Input size='large' disabled={disabled} />
                  </InputWithValue> */}
                </Form.Item>

                <Form.Item
                  initialValue={8883}
                  name='port'
                  className={css.port}
                  rules={[{ required: true }]}
                  style={{
                    display: 'inline-block',
                    width: 'calc(50% - 8px)',
                    margin: '0 8px',
                  }}>
                  <InputWithValue edit={editable}>
                    <Input size='large' disabled={disabled} />
                  </InputWithValue>
                </Form.Item>
              </Form.Item>
            ),
          },
        ]}
      />
      <Row
        elements={[
          {
            child: (
              <Form.Item
                name='destination'
                labelCol={{ span: 24 }}
                label={
                  <Label
                    title={`${getI18n(
                      'storeCommunicationSetting.detail.messageDestination',
                    )}*`}
                  />
                }>
                <RadioWithValue edit={editable} options={destinationOptions}>
                  <Select
                    size='large'
                    optionsList={destinationOptions}
                    disabled={disabled}
                  />
                </RadioWithValue>
              </Form.Item>
            ),
          },
          {
            child: null,
          },
        ]}
      />
    </Fragment>
  );
};

export default Cloopen;
